import { Tabs, TabsProps } from "antd";

import RingFenceTab from "./RingFenceTab";
import { ScenarioConfigurationTable } from "./ScenarioConfigurationTable";
import ScenarioSticks from "./ScenarioSticks";

export const ScenarioTabs = ({
  showFullPadScenario,
  isStickManagementMode,
  containerHeight,
  editId,
  onNewRow,
  onRunScenario,
  isLoading
}) => {
  const tabItems: TabsProps["items"] = showFullPadScenario
    ? [
        {
          key: "Wells",
          label: "Sticks",
          children: (
            <ScenarioSticks
              showFullPadScenario={showFullPadScenario}
              isStickManagementMode={isStickManagementMode}
            />
          )
        },
        {
          key: "Ring Fence",
          label: "Ring Fence",
          children: <RingFenceTab containerHeight={containerHeight} />
        },
        {
          key: "Layer Configuration",
          label: "Layer Configuration",
          children: (
            <ScenarioConfigurationTable
              containerHeight={containerHeight}
              editId={editId}
              onNewRow={onNewRow}
              onRunScenario={onRunScenario}
              isLoading={isLoading}
              showFullPadScenario={showFullPadScenario}
            />
          )
        }
      ]
    : [
        {
          key: "Wells",
          label: "Sticks",
          children: (
            <ScenarioSticks
              showFullPadScenario={showFullPadScenario}
              isStickManagementMode={isStickManagementMode}
            />
          )
        },
        {
          key: "Ring Fence",
          label: "Ring Fence",
          children: <RingFenceTab containerHeight={containerHeight} />
        }
      ];

  return <Tabs items={tabItems} />;
};
